// -------------- Hook to call the api endpoint for the macro data ------------------
// ----------------------------------------------------------------------------------
// import react libraries and api service functions
import { useState, useEffect, useCallback } from 'react';
import { getMacroData } from '../services/api';

// hook to fetch macroeconomic data based on the specified timeframe
export const useMacroData = (timeframe = 'MAX') => {

  // define state variables used in the hook
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // function to collect the data from the api
  const fetchData = useCallback(async () => {
    try {
      // set loading and error states
      setLoading(true);
      setError(null);
      
      // call the api service function to get macro data
      const response = await getMacroData({ timeframe });
      
      if (!response) { // check if the response is valid
        throw new Error('No macro data received');
      }
      
      setData(response);

    } catch (err) { // handle any errors that occur during the fetch
      console.error('Error fetching macro data:', err);
      setError(err.message || 'Failed to fetch macro data');
      setData(null);

    } finally { // set loading to false after the fetch is complete
      setLoading(false);
    }
  }, [timeframe]); // useCallback ensures that fetchData is only recreated if the timeframe changes

  useEffect(() => { // reset data and loading state when the timeframe changes
    setData(null);
    setLoading(true);

  }, [timeframe]);

  useEffect(() => { // call the fetchData function when the component mounts 
    fetchData();

  }, [fetchData]);

  return { 
    data, 
    loading, 
    error, 
    refetch: fetchData 
  }; // return the states and refetch function
};